
<table border="1" cellspacing="0" cellpadding="8" *ngIf="data?.length">
  <thead>
    <tr>
      <th *ngFor="let key of objectKeys(data[0])">
        {{ key }}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of data">
      <td *ngFor="let key of objectKeys(item)">
        {{ item[key] }}
      </td>
    </tr>
  </tbody>
</table>
